import { triggerEvent } from '../utilities/utilities';

document.addEventListener('click', ev => {
  triggerEvent('customClick', document, ev);
});
